import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'CompanyStatistics';

const Types = merge(
    {
        mutations: {
            SET_STATISTICS: 'setStatistics',
        },
        actions: {
            LOAD_STATISTICS: 'loadStatistics',
            LOAD_STATISTICS_ALL: 'loadStatisticsAll',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
